import React, { Component } from "react";
import { ActionButton, Grid } from "@culturehq/components";
import client from "@culturehq/client";
import { useLazyImport } from "@culturehq/hooks";

import { t, Trans } from "app/utils";
import ErrorModal from "components/display/ErrorModal";

import SurveyItemResponseOption from "./SurveyItemResponseOption";
import styles from "./survey-item-response-options.module.scss";

class SurveyItemResponseOptionsInner extends Component {
  responseOptionsRef = React.createRef();

  constructor(props) {
    super(props);

    const { responseOptions } = this.props;

    this.state = {
      text: "",
      responseOptions: responseOptions || [],
      error: null
    };
  }

  componentDidMount() {
    const { Sortable } = this.props;

    this.sortable = new Sortable(this.responseOptionsRef.current, {
      handle: ".sortable__drag-handler",
      onEnd: this.handleSort
    });
  }

  handleAdd = async event => {
    const { surveyItemId } = this.props;
    const { text, responseOptions } = this.state;

    if (event) {
      event.preventDefault();
    }

    if (!text) {
      return;
    }

    responseOptions.push({
      surveyItemId,
      body: text,
      key: new Date().getTime(),
      position: 100
    });

    this.setState({ text: "", responseOptions }, this.handleChange);
  };

  handleSort = async event => {
    this.sortable.option("disabled", true);

    const { responseOptions } = this.state;
    const responseOptionElements = Array.from(event.to.children);

    responseOptionElements.forEach((optionElement, position) => {
      const identifier = optionElement.getAttribute("data-id");
      const found = responseOptions.find(
        ({ id, key }) => (id || key).toString() === identifier
      );
      found.position = position;
    });

    this.setState({ responseOptions });
    this.handleChange();
    this.sortable.option("disabled", false);
  };

  handleTextChange = ({ target: { value: text } }) => {
    this.setState({ text });
  };

  handleRemove = option => {
    this.setState(
      ({ responseOptions }) => ({
        responseOptions: responseOptions.filter(({ key }) => key !== option.key)
      }),
      this.handleChange
    );
  };

  handleDelete = async option => {
    const { surveyItemId } = this.props;

    if (!option.id) {
      this.handleRemove(option);
      return;
    }

    try {
      await client.deleteSurveyItemResponseOption({
        surveyItemId, surveyItemResponseOptionId: option.id
      });

      this.setState(
        ({ responseOptions }) => ({
          responseOptions: responseOptions.filter(({ id }) => id !== option.id)
        }),
        this.handleChange
      );
    } catch (error) {
      this.setState({ error });
    }
  };

  handleChange = () => {
    const { onChange } = this.props;
    const { responseOptions } = this.state;

    if (onChange) {
      onChange(responseOptions);
    }
  };

  render() {
    const { error, text } = this.state;
    let { responseOptions = [] } = this.state;

    responseOptions = responseOptions.sort(
      (optionA, optionB) => optionA.position - optionB.position
    );

    return (
      <>
        <div className="chart">
          <div ref={this.responseOptionsRef}>
            {responseOptions.map(responseOption => (
              <SurveyItemResponseOption
                key={responseOption.key || responseOption.id}
                responseOption={responseOption}
                onDelete={this.handleDelete}
              />
            ))}
          </div>
          <ErrorModal error={error} />
          <form className={styles.form} onSubmit={this.handleAdd}>
            <Grid className={styles.grid}>
              <Grid.Item xs={8}>
                <input
                  aria-label={t("Enter an answer option")}
                  type="text"
                  className="form-control"
                  name="search"
                  onChange={this.handleTextChange}
                  value={text}
                />
              </Grid.Item>
              <Grid.Item xs={4}>
                <ActionButton icon="plus" onClick={this.handleAdd}>
                  <Trans>Add Choice</Trans>
                </ActionButton>
              </Grid.Item>
            </Grid>
          </form>
        </div>
      </>
    );
  }
}

const SurveyItemResponseOptions = props => {
  const Sortable = useLazyImport(() => import("sortablejs"));

  return Sortable ? <SurveyItemResponseOptionsInner {...props} Sortable={Sortable} /> : null;
};

export default SurveyItemResponseOptions;
